import LabeledTextField from '@src/components/CustomTextField/LabeledTextField';
import {
	Autocomplete,
	Box,
	Paper,
	IconButton,
	SelectChangeEvent,
	Typography,
	styled,
	Stack,
	Button,
} from '@mui/material';
import { FormikProps } from 'formik';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import React, { useEffect, useState } from 'react';
import AutoComplete from '@src/components/CustomSelect/AutoComplete';
import {
	BuyerTypeOptions,
	PurchaseFrequencyOptions,
	PurchaseModeOptions,
} from '@src/pages/Register/utils';

function PartsDetails({ parts, setParts }: any) {
	function validateAverageSpendOnPartsPerMonth() {
		if (
			parts?.averageSpendOnPartsPerMonth?.length &&
			(isNaN(Number(parts?.averageSpendOnPartsPerMonth)) ||
				Number(parts?.averageSpendOnPartsPerMonth) < 0)
		) {
			return 'Average spend on parts per month must be a number and greater than 0';
		}
		return null;
	}

	return (
		<Box display="flex" flexDirection="column" gap={2}>
			<AutoComplete
				selectedOption={BuyerTypeOptions?.find((option) => option.id === parts.buyerType) || null}
				options={BuyerTypeOptions}
				onChange={(newValue) => {
					setParts({ ...parts, buyerType: newValue?.id || '' });
				}}
				label="Who purchases parts?"
				// error={Boolean(parts.partsPurchaser && parts.partsPurchaser)}
			/>

			<AutoComplete
				selectedOption={
					PurchaseModeOptions?.filter((option) => parts.modeOfPurchase?.includes(option.id)) || []
				}
				options={PurchaseModeOptions}
				onChange={(newValue) => {
					if (Array.isArray(newValue)) {
						setParts({ ...parts, modeOfPurchase: newValue.map((item) => item.id) });
					} else {
						setParts({ ...parts, modeOfPurchase: [newValue?.id] });
					}
				}}
				label="Purchase Mode"
				// error={Boolean(parts.purchaseMode && parts.purchaseMode)}
				multiple={true}
			/>

			<AutoComplete
				selectedOption={
					PurchaseFrequencyOptions?.find(
						(option) => option.id === parts.frequencyOfPartsPurchase
					) || null
				}
				options={PurchaseFrequencyOptions}
				onChange={(newValue) => {
					setParts({ ...parts, frequencyOfPartsPurchase: newValue?.id || '' });
				}}
				label="Purchase Frequency"
				// error={Boolean(parts.purchaseFrequency && parts.purchaseFrequency)}
			/>

			<LabeledTextField
				label="Commonly Purchased Parts"
				value={parts.commonlyPurchasedPartsCategories}
				onChange={(e) => setParts({ ...parts, commonlyPurchasedPartsCategories: e.target.value })}
				multiline
				rows={4}
				// error={Boolean(parts.commonParts && parts.commonParts)}
				styles={{ width: '100%' }}
			/>

			<LabeledTextField
				label="Monthly Spend on Parts (₹)"
				value={parts.averageSpendOnPartsPerMonth}
				onChange={(e) => setParts({ ...parts, averageSpendOnPartsPerMonth: e.target.value })}
				error={validateAverageSpendOnPartsPerMonth() ? true : false}
				errorText={validateAverageSpendOnPartsPerMonth()}
				styles={{ width: '100%' }}
			/>
		</Box>
	);
}

export default PartsDetails;
